import BlurTextField, { IBlurTextFieldProps } from '../../../components/connectedForm/BlurTextField/BlurTextField';
import React, { useContext, useMemo, useState } from 'react';
import ConnectedFormContext from '../../../components/Context/ConnectedFormContext';
import { useDispatch } from 'react-redux';
import ModalContext from '../../../components/Context/ModalContext';
import { BasicHeader } from '../../../actions/BasicHeader';
import SalesOrderDeliveryAddressWorkspace from '../SalesOrderDeliveryAddressWorkspace';
import { ModalBottomButtonContainer } from '../../../components/modals/Styles';
import { SecondaryButton } from '../../../components/connectedForm/Button';
import { IFilterInput, ISalesOrderDeliveryAddress } from '../../../graphql/schema/p4types';
import { SearchSuffix } from '../../../components/SelectModal/SelectModal';
import FluentModal from '../../../components/modals/FluentModal';

/**
 * Delivery Name field enhanced with a lookup glyph that presents a full Workspace of previous delivery addresses.
 * @param predefinedFilters - Filter the delivery addresses (Expecting a customer id filter).
 * @param dataid - Data id for the deliveryName field.
 * @param addressDataId - Data id for the deliveryAddress field.
 * @param blurTextFieldProps - Any other props for passing through to the main BlurTextField component.
 */
export const DeliveryLookupField = ({
  predefinedFilters,
  dataid,
  addressDataId,
  ...blurTextFieldProps
}: IBlurTextFieldProps & { predefinedFilters: Array<IFilterInput>; dataid: string; addressDataId: string }) => {
  const [deliveryLookupOpen, setDeliveryLookupOpen] = useState(false);
  const { change } = useContext(ConnectedFormContext);
  const dispatch = useDispatch();

  const modalContext = useMemo(() => {
    return { onClose: () => setDeliveryLookupOpen(false) };
  }, []);

  return (
    <>
      <FluentModal isOpen={deliveryLookupOpen} styles={{ main: { minWidth: '800px', paddingBottom: '60px' } }}>
        <ModalContext.Provider value={modalContext}>
          <BasicHeader>Previous Address Lookup</BasicHeader>
          <div style={{ padding: '1em' }}>
            <SalesOrderDeliveryAddressWorkspace
              embeddedView={true}
              predefinedFilters={predefinedFilters}
              viewScreenName="/Sales/DeliveryAddress/Modal"
              removeAddButton={true}
              contentHeight={500}
              onBack={() => setDeliveryLookupOpen(false)}
              onRowClick={(value: ISalesOrderDeliveryAddress) => {
                if (!value) {
                  return;
                }
                dispatch(change(dataid, value.deliveryName));
                dispatch(change(addressDataId, value.deliveryAddress));
                setDeliveryLookupOpen(false);
              }}
            />
          </div>
          <ModalBottomButtonContainer>
            <SecondaryButton onClick={() => setDeliveryLookupOpen(false)}>Close</SecondaryButton>
          </ModalBottomButtonContainer>
        </ModalContext.Provider>
      </FluentModal>
      <BlurTextField
        {...blurTextFieldProps}
        inputSuffix={
          <SearchSuffix
            onClick={() => {
              setDeliveryLookupOpen(true);
            }}
            style={{ marginLeft: '-44px' }}
          />
        }
      />
    </>
  );
};
